import React from 'react';

export const Footer = () => {
    return(
        <footer id="app-footer">
            App elle&la {new Date().getFullYear()}
        </footer>
    )
};